module.exports = __webpack_public_path__ + "media/images/app/subscriptions/step-3-3a0ba54145907ed07af81eb62fc1c1e8.webp";